import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {Debugger} from "debug";
import {IQService} from "angular";

const debug: Debugger = require('debug')('CriiptoOIDCRessurs');

export class CriiptoOIDCRessurs {
    static regNavn = "CriiptoOIDCRessurs";

    static forInjisering() {
        return [
            "$resource",
            RessursFeilhåndtering.regNavn,
            regNavn.ng.$q,
            regNavn.gettext.gettextCatalog,
            CriiptoOIDCRessurs
        ]
    }

    private ressurs: ng.resource.IResourceClass<any>;

    constructor(private $resource: ng.resource.IResourceService,
                private ressursFeilhåndtering: RessursFeilhåndtering,
                private $q: IQService,
                private gettextCatalog: gettextCatalog) {
        this.ressurs = $resource<any>("/api/autentisering/criipto", {}, {
            authorizeUrl: {method: "GET", url: "/api/autentisering/criipto/authorizeUrl/:guimodus/:tilbyder?redirect=false&loginHint=:loginHint", params: {guimodus: '@guimodus', tilbyder: '@tilbyder', loginHint: '@loginHint'}},
            autentiser: {method: "POST", url: "/api/autentisering/criipto/autentiser"},
            bindAutentisertBruker: {method: "PUT", url: "/api/autentisering/criipto/bindAutentisertBruker"},
            bindIkkeAutentisertBrukerFraToken: {method: "PUT", url: "/api/autentisering/criipto/bindIkkeAutentisertBrukerFraToken"},
            deaktiverOpenIdBinding: {method: "POST", url: "/api/autentisering/criipto/deaktiverOpenIdBinding"}
        });
    }


    /** henter url som benyttes for å vise openid autentiseringsgui */
    authorizeUrl(guimodus: l.CriiptoGuiModus, tilbyder:l.CriiptoIdTilbyder, loginHint:string = null): l.AuthorizeUrlModell {
        debug("authorizeUrl", guimodus, tilbyder, loginHint)
        return this.ressurs["authorizeUrl"](
            {guimodus: guimodus, tilbyder: tilbyder, loginHint:loginHint},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente authorizeUrl"))
        );
    }

    /** Returnerer url som redirigerer klient til url som benyttes for å vise openid autentiseringsgui.
     * Bør normalt foretrekkes fremfor authorizeUrl(..) da vi her unngår problemet med at popup bli blokkert som følge av promise. */
    redirectTilAuthorizeUrl(guimodus: l.CriiptoGuiModus, tilbyder:l.CriiptoIdTilbyder): string {
        debug("redirectTilAuthorizeUrl", guimodus, tilbyder)
        return `/api/autentisering/criipto/authorizeUrl/${guimodus}/${tilbyder}?redirect=true`;
    }

    /** sender kode mottatt fra autentiseringsgui til server slik at server kan bruke denne for å resolve autentisert bruker mot criipto
     * Dersom ingen bruker er knyttet til openid subject vil returnert {@link CriiptoAutentiseringsResponsModell#lederplanRespons}
     * ha {@link AutentiseringResponsModell#ukjentSubject} satt.
     * Dersom bruker i styreplan er tilknyttet openid subject vil {@link CriiptoAutentiseringsResponsModell#styreplanRespons}
     * være ikke-null */
    autentiser(spesifikasjon: l.CriiptoTokenInnloggingsSpesifikasjon): l.CriiptoAutentiseringsResponsModell {
        debug("autentiser", spesifikasjon)
        return this.ressurs["autentiser"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("En feil oppstod under autentisering, vennligst forsøk på nytt"))
        );
    }

    bindAutentisertBruker(spesifikasjon: l.CriiptoBindBrukerSpesifikasjon) : l.AutentiseringResponsModell {
        debug("bindAutentisertBruker", spesifikasjon)
        return this.ressurs["bindAutentisertBruker"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("En feil oppstod under kobling av din konto, vennligst forsøk på nytt"))
        );
    }

    bindIkkeAutentisertBrukerFraToken(spesifikasjon: l.CriiptoBindFraTokenSpesifikasjon) : l.AutentiseringResponsModell {
        debug('bindIkkeAutentisertBrukerFraToken', spesifikasjon)
        return this.ressurs["bindIkkeAutentisertBrukerFraToken"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString("En feil oppsto under kobling av din konto. Vennligst forsøk glemt passord igjen."))
        )
    }

    deaktiverOpenIdBinding(spesifikasjon: l.DeaktiverOpenIdBindingSpesifikasjon): l.DeaktivertOpenIdBindingModell {
        debug("deaktiverOpenIdBinding", spesifikasjon)
        return this.ressurs["deaktiverOpenIdBinding"](
            spesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("En feil oppstod under deaktivering av open-id-binding på din konto, vennligst forsøk på nytt"))
        );
    }

    private håndterFeil(melding: () => string){
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }
}
